import React from "react";
import { connect, useDispatch } from "react-redux";
import { Formik } from "formik";

import { Collapsible, Select, SubmitButton, TextInput } from "components/forms";
import { Form } from "react-bootstrap";
import { isEmpty } from "lodash";
import { partial, prepareMultipleSelect } from "../../../utils";
import { createDomain, editDomain, showModal } from "actions";
import { DOMAIN_MODAL } from "../../../components/modals";
import { activeDomainSelector, managementChoicesSelector } from "../../../reducers";
import SelectInlineLabel from "../../../components/forms/selects/SelectInlineLabel";
import { DOMAIN_ACCOUNT_TYPES } from "./constants";

export const DOMAIN_TYPES = [
  { value: 1, label: "Protected" },
  { value: 2, label: "Common" },
];

const DomainForm = ({ domain, ...props }) => {
  const dispatch = useDispatch();
  let isSaved = domain && domain.id;
  let title = isSaved ? "Edit Domain" : "New Domain";

  let [accountType, setAccountType] = React.useState();
  const handleAccountTypeChange = selectedOptions => {
    if (selectedOptions) {
      const commaSeparatedValues = selectedOptions.map(o => o.value).join(",");
      setAccountType(commaSeparatedValues);
    } else {
      setAccountType(undefined);
    }
  };
  let account_type_initial = prepareMultipleSelect("account_type", DOMAIN_ACCOUNT_TYPES, domain || {});

  return (
    <Formik
      enableReinitialize
      initialValues={{ ...domain }}
      onSubmit={async (values, { setSubmitting, setErrors }) => {
        values.account_type = accountType || "";
        const method =
          isEmpty(domain) || domain.id === undefined
            ? partial(props.createDomain, values, setErrors)
            : partial(props.editDomain, domain.id, values, setErrors);

        await method();
        dispatch(props.hideModal(DOMAIN_MODAL));
        setSubmitting(false);
      }}
    >
      {({ handleSubmit, values, setFieldValue }) => {
        return (
          <div>
            <Form onSubmit={handleSubmit} style={{ marginBottom: "-10px" }} {...props}>
              <Collapsible title={title} darker={true}>
                <Form.Row>
                  <TextInput label="URL" name="url" required={true} />
                  <TextInput label="Company Name" name="company_name" />
                </Form.Row>
                <Form.Row>
                  <SelectInlineLabel
                    label="Domain Type"
                    name="type"
                    placeholder="Select Type"
                    defaultValue={1}
                    options={DOMAIN_TYPES}
                  />
                  <Select
                    label="Account Type"
                    name="account_type"
                    placeholder="Select Account Type(s)"
                    options={DOMAIN_ACCOUNT_TYPES}
                    isMulti={true}
                    onChange={handleAccountTypeChange}
                    defaultValue={account_type_initial}
                  />
                </Form.Row>
                <Form.Row>
                  <Select
                    label="Sales Rep"
                    name="sales_representative_id"
                    placeholder="Select Sales Rep"
                    options={props.salesRepChoices?.getChoices({ sortByLabel: true }) || []}
                    required={values.type === 1 || values.type === undefined}
                    md={6}
                  />
                </Form.Row>
                <SubmitButton />
              </Collapsible>
            </Form>
          </div>
        );
      }}
    </Formik>
  );
};

const mapStateToProps = state => {
  const choices = managementChoicesSelector(state);

  return {
    domain: activeDomainSelector(state),
    salesRepChoices: choices.case_sales_representatives,
  };
};

export default connect(mapStateToProps, {
  createDomain,
  editDomain,
  showModal,
})(DomainForm);
